export const FIXED_DESKTOP_EMBED_WIDTH = 980;

export function isFixedDesktopEmbed(source) {
  if (!source) {
    return false;
  }

  try {
    const hostname = new URL(source).hostname.toLowerCase();
    return hostname === 'gastrotourchinoin.com' || hostname.endsWith('.gastrotourchinoin.com');
  } catch (error) {
    return false;
  }
}

export function calculateEmbedScale(availableWidth, contentWidth = FIXED_DESKTOP_EMBED_WIDTH) {
  const parsedAvailableWidth = Number(availableWidth);
  const parsedContentWidth = Number(contentWidth);

  if (!Number.isFinite(parsedAvailableWidth) || parsedAvailableWidth <= 0 ||
      !Number.isFinite(parsedContentWidth) || parsedContentWidth <= 0) {
    return 1;
  }

  return Math.min(1, parsedAvailableWidth / parsedContentWidth);
}

export function calculateEmbedDimensions(
  containerWidth,
  containerHeight,
  contentWidth = FIXED_DESKTOP_EMBED_WIDTH
) {
  const parsedWidth = Number(containerWidth);
  const parsedHeight = Number(containerHeight);

  if (!Number.isFinite(parsedWidth) || parsedWidth <= 0 ||
      !Number.isFinite(parsedHeight) || parsedHeight <= 0) {
    return null;
  }

  const scale = calculateEmbedScale(parsedWidth, contentWidth);
  return {
    height: Math.floor(parsedHeight / scale),
    scale
  };
}

export function shouldPreserveEmbedDimensions(
  visualViewportScale,
  containerWidth,
  previousContainerWidth
) {
  const parsedVisualScale = Number(visualViewportScale);
  const parsedWidth = Number(containerWidth);
  const parsedPreviousWidth = Number(previousContainerWidth);

  return Number.isFinite(parsedVisualScale) && parsedVisualScale > 1.01 &&
    Number.isFinite(parsedWidth) &&
    Number.isFinite(parsedPreviousWidth) && parsedPreviousWidth > 0 &&
    parsedWidth === parsedPreviousWidth;
}
